/* ==========================================================================
   Widerruf-Funktion – Frontend-Logik
   - Vorbefüllung aus URL-Parametern (?order=...&email=...)
   - Client-Validierung mit verständlichen, barrierearmen Fehlermeldungen
   - Zwei-Schritt-Bestätigung (Eingabe -> Prüfen -> verbindlich absenden)
   - Honeypot + Zeitfalle gegen Bots
   - POST an den eigenen Backend-Endpunkt (keine Secrets im Theme)
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-widerruf-root]');
  if (!root) return;

  var endpoint = root.getAttribute('data-endpoint') || '';
  var form     = root.querySelector('[data-widerruf-form]');
  var confirm  = root.querySelector('[data-widerruf-confirm]');
  var summary  = root.querySelector('[data-widerruf-summary]');
  var success  = root.querySelector('[data-widerruf-success]');
  var successRef = root.querySelector('[data-widerruf-ref]');
  var alertBox = root.querySelector('[data-widerruf-alert]');
  var sending  = root.querySelector('[data-widerruf-sending]');
  var btnNext  = root.querySelector('[data-widerruf-next]');
  var btnBack  = root.querySelector('[data-widerruf-back]');
  var btnSend  = root.querySelector('[data-widerruf-send]');

  // Zeitpunkt des Renderns – Bots senden oft in < 2s ab.
  var renderedAt = Date.now();

  // Sicherheits-Token (CSRF/Zeitfalle) vom Backend holen.
  var securityToken = '';
  var tokenEndpoint = endpoint.replace(/\/withdrawal\b/, '/withdrawal-token');
  function loadToken() {
    if (!tokenEndpoint || tokenEndpoint === endpoint) return;
    fetch(tokenEndpoint, { method: 'GET', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j.token) securityToken = j.token; })
      .catch(function () { /* tolerant: Backend akzeptiert auch ohne Token (Honeypot/Origin greifen) */ });
  }

  /* ---------- Felddefinitionen ---------- */
  var FIELDS = [
    { name: 'vorname',      label: 'Vorname',       required: true },
    { name: 'nachname',     label: 'Nachname',      required: true },
    { name: 'email',        label: 'E-Mail-Adresse', required: true, type: 'email' },
    { name: 'bestellnummer',label: 'Bestellnummer', required: true },
    { name: 'artikel',      label: 'Produkt / Artikel', required: false },
    { name: 'nachricht',    label: 'Nachricht',     required: false }
  ];

  /* ---------- Vorbefüllung aus URL ---------- */
  function prefillFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var order = params.get('order');
      var email = params.get('email');
      if (order) setVal('bestellnummer', order);
      if (email) setVal('email', email);
    } catch (e) { /* URLSearchParams nicht verfügbar -> ignorieren */ }
  }
  function setVal(name, val) {
    var el = form.querySelector('[name="' + name + '"]');
    if (el && !el.value) el.value = val;
  }
  function field(name) { return form.querySelector('[name="' + name + '"]'); }
  function errEl(name) { return form.querySelector('[data-error-for="' + name + '"]'); }

  /* ---------- Validierung ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function validate() {
    var errors = [];
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      var val = (el.value || '').trim();
      clearError(f.name);

      if (f.required && !val) {
        errors.push({ name: f.name, msg: 'Bitte ' + f.label + ' ausfüllen.' });
        return;
      }
      if (f.type === 'email' && val && !EMAIL_RE.test(val)) {
        errors.push({ name: f.name, msg: 'Bitte eine gültige E-Mail-Adresse eingeben.' });
      }
    });

    // Checkbox
    var cb = field('bestaetigung');
    clearError('bestaetigung');
    if (cb && !cb.checked) {
      errors.push({ name: 'bestaetigung', msg: 'Bitte bestätige die Widerrufserklärung.' });
    }

    return errors;
  }

  function showErrors(errors) {
    errors.forEach(function (e) {
      var box = errEl(e.name);
      var input = field(e.name);
      if (box) { box.textContent = e.msg; box.hidden = false; }
      if (input) input.setAttribute('aria-invalid', 'true');
    });

    if (errors.length) {
      alertBox.textContent = errors.length === 1
        ? 'Bitte korrigiere die markierte Eingabe.'
        : 'Bitte korrigiere die ' + errors.length + ' markierten Eingaben.';
      alertBox.hidden = false;
      // Fokus auf erstes Fehlerfeld
      var first = field(errors[0].name);
      if (first) first.focus();
    }
  }

  function clearError(name) {
    var box = errEl(name);
    var input = field(name);
    if (box) { box.textContent = ''; box.hidden = true; }
    if (input) input.removeAttribute('aria-invalid');
  }

  function clearAllErrors() {
    alertBox.hidden = true;
    alertBox.textContent = '';
    FIELDS.forEach(function (f) { clearError(f.name); });
    clearError('bestaetigung');
  }

  // Live: Fehler entfernen, sobald der Nutzer korrigiert
  form.addEventListener('input', function (ev) {
    var name = ev.target && ev.target.name;
    if (name) clearError(name);
  });

  /* ---------- Daten einsammeln ---------- */
  function collect() {
    return {
      vorname:       (field('vorname').value || '').trim(),
      nachname:      (field('nachname').value || '').trim(),
      email:         (field('email').value || '').trim(),
      bestellnummer: (field('bestellnummer').value || '').trim(),
      artikel:       (field('artikel').value || '').trim(),
      nachricht:     (field('nachricht').value || '').trim(),
      bestaetigung:  !!field('bestaetigung').checked,
      website:       (field('website') ? field('website').value : ''), // Honeypot
      token:         securityToken,
      rendered_at:   renderedAt,
      elapsed_ms:    Date.now() - renderedAt
    };
  }

  /* ---------- Schritt 2: Zusammenfassung rendern ---------- */
  function renderSummary(data) {
    var rows = [
      ['Vorname', data.vorname],
      ['Nachname', data.nachname],
      ['E-Mail-Adresse', data.email],
      ['Bestellnummer', data.bestellnummer]
    ];
    if (data.artikel)   rows.push(['Produkt / Artikel', data.artikel]);
    if (data.nachricht) rows.push(['Nachricht', data.nachricht]);

    summary.innerHTML = '';
    rows.forEach(function (r) {
      var row = document.createElement('div');
      row.className = 'widerruf-summary__row';
      var dt = document.createElement('dt');
      dt.textContent = r[0];
      var dd = document.createElement('dd');
      dd.textContent = r[1];
      row.appendChild(dt);
      row.appendChild(dd);
      summary.appendChild(row);
    });
  }

  /* ---------- Turnstile-Token lesen (falls aktiv) ---------- */
  function turnstileToken() {
    var el = root.querySelector('[name="cf-turnstile-response"]');
    return el ? el.value : '';
  }

  /* ---------- Step-Wechsel ---------- */
  function goToConfirm() {
    var errors = validate();
    if (errors.length) { showErrors(errors); return; }

    renderSummary(collect());
    form.hidden = true;
    confirm.hidden = false;
    confirm.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (btnSend) btnSend.focus();
  }

  function goBack() {
    confirm.hidden = true;
    form.hidden = false;
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ---------- Absenden ---------- */
  function send() {
    var data = collect();

    // Zeitfalle (Mensch braucht > 2s)
    if (data.elapsed_ms < 2000) {
      // Stiller Abbruch wie bei Bot – aber Nutzer-Feedback geben
      showFatal('Bitte einen Moment warten und erneut absenden.');
      return;
    }

    data.turnstile_token = turnstileToken();

    btnSend.disabled = true;
    btnBack.disabled = true;
    sending.hidden = false;

    if (!endpoint) {
      showFatal('Der Widerruf-Endpunkt ist nicht konfiguriert. Bitte kontaktiere den Shop.');
      resetSendUi();
      return;
    }

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          return { ok: res.ok, status: res.status, body: body };
        });
      })
      .then(function (r) {
        if (r.ok && r.body && r.body.success) {
          showSuccess(r.body.reference);
        } else {
          var msg = (r.body && r.body.error)
            ? r.body.error
            : 'Die Übermittlung ist fehlgeschlagen. Bitte versuche es später erneut oder kontaktiere uns per E-Mail.';
          showFatal(msg);
          resetSendUi();
        }
      })
      .catch(function () {
        showFatal('Verbindung fehlgeschlagen. Bitte prüfe deine Internetverbindung und versuche es erneut.');
        resetSendUi();
      });
  }

  function resetSendUi() {
    btnSend.disabled = false;
    btnBack.disabled = false;
    sending.hidden = true;
  }

  function showSuccess(reference) {
    form.hidden = true;
    confirm.hidden = true;
    success.hidden = false;
    if (reference && successRef) {
      successRef.textContent = 'Referenz: ' + reference;
      successRef.hidden = false;
    }
    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    success.focus && success.focus();
  }

  function showFatal(msg) {
    // Fehler im jeweils sichtbaren Schritt anzeigen
    alertBox.textContent = msg;
    alertBox.hidden = false;
    if (!form.hidden) {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      // Im Confirm-Schritt: Alert temporär dort einblenden
      window.alert(msg);
    }
  }

  /* ---------- Events ---------- */
  // Schritt 1 ist ein echter Submit-Button -> Standard verhindern
  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    goToConfirm();
  });
  if (btnBack) btnBack.addEventListener('click', goBack);
  if (btnSend) btnSend.addEventListener('click', send);

  prefillFromUrl();
  loadToken();
})();
